import Splide from "@splidejs/splide";

// SPLIDE ARTICLE
var splideArticleEls = document.querySelectorAll(".splide-article");
splideArticleEls.forEach(function (el) {
	new Splide(el, {
		type: "slide",
		perPage: 1,
		arrows: true,
		pagination: false,
	}).mount();
});

// SPLIDE CARDS w/progressbar
document.querySelectorAll(".splide-cards").forEach(function (el) {
	var splide = new Splide(el, {
		type: "slide",
		perPage: 1,
		gap: "1rem",
		arrows: true,
		pagination: false,
		focus: "center",
		padding: { right: "10%" },
		mediaQuery: "min",
		breakpoints: {
			767: {
				perPage: 2,
				gap: "1.5rem",
				focus: 1,
				padding: 0,
			},
			992: {
				perPage: 3,
				gap: "2rem",
				focus: 1,
				padding: 0,
			},
		},
	});

	// Progress bar logic (scoped to this slider)
	var progress = el.querySelector(".splide-progressbar__bar");
	if (progress) {
		splide.on("mounted move", function () {
			if (window.innerWidth >= 768) {
				var end = splide.Components.Controller.getEnd() + 1;
				var rate = Math.min((splide.index + 1) / end, 1);
				progress.style.width = String(100 * rate) + "%";
			} else {
				progress.style.width = "0";
			}
		});
	}

	splide.mount();
});

// SPLIDE SERVICE CARDS w/progressbar
document.querySelectorAll(".splide-service-cards").forEach(function (el) {
	var splide = new Splide(el, {
		type: "slide",
		perPage: "auto",
		gap: "1rem",
		arrows: true,
		pagination: false,
		focus: "center",
		padding: { right: "10%" },
		mediaQuery: "min",
		breakpoints: {
			767: {
				perPage: 2,
				gap: "1.5rem",
				focus: 1,
				padding: 0,
			},
			992: {
				perPage: 3,
				gap: "2rem",
				focus: 1,
				padding: 0,
			},
			1200: {
				perPage: 4,
				gap: "2rem",
				focus: 1,
				padding: 0,
			},
		},
	});

	// Progress bar logic (scoped to this slider)
	var progress = el.querySelector(".splide-progressbar__bar");
	if (progress) {
		splide.on("mounted move", function () {
			if (window.innerWidth >= 768) {
				var end = splide.Components.Controller.getEnd() + 1;
				var rate = Math.min((splide.index + 1) / end, 1);
				progress.style.width = String(100 * rate) + "%";
			} else {
				progress.style.width = "0";
			}
		});
	}

	splide.mount();
});
